(function () {
  'use strict';

  let data = null;
  let selectedApplication = null;
  let selectedMotor = null;
  let selectedController = null;
  let batteryVoltage = 48;
  let chart = null;
  let selectedVendor = '';

  const elements = {};

  function init() {

    const script = document.getElementById('configurator-data');
    if (!script) return;

    data = JSON.parse(script.textContent);

    elements.motorSelect = document.getElementById('motor-select');
    elements.controllerSelect = document.getElementById('controller-select');
    elements.motorSpecs = document.getElementById('motor-specs');
    elements.controllerSpecs = document.getElementById('controller-specs');
    elements.combinedSpecs = document.getElementById('combined-specs');
    elements.chartSection = document.getElementById('chart-section');
    elements.chartCanvas = document.getElementById('torque-chart');
    elements.voltageDisplay = document.getElementById('battery-voltage-display');

    populateDropdowns();

    elements.motorSelect.addEventListener('change', onMotorChange);
    elements.controllerSelect.addEventListener('change', onControllerChange);

    setupVendorButtons();
    setupVoltagePills();
    restoreFromURL();
    setupApplicationIcons();
  }

  // =========================
  // DROPDOWNS
  // =========================

  function populateDropdowns() {

    elements.motorSelect.innerHTML = '<option value="">— Choose a motor —</option>';
    data.motors
  .filter(m =>
    !selectedVendor ||
    m.vendor === selectedVendor
  )
  .forEach(m => {
      const opt = document.createElement('option');
      opt.value = m.id;
      opt.textContent = m.title;
      elements.motorSelect.appendChild(opt);
    });

    elements.controllerSelect.innerHTML = '<option value="">— Choose a controller —</option>';
    data.controllers.forEach(c => {
      const opt = document.createElement('option');
      opt.value = c.id;
      opt.textContent = c.title;
      elements.controllerSelect.appendChild(opt);
    });
  }

  function filterByVoltage() {
    // ✅ FILTER MOTORS
    const motorOptions = elements.motorSelect.querySelectorAll('option');

    motorOptions.forEach(opt => {
      const id = parseInt(opt.value, 10);
      if (!id) return;

      const motor = data.motors.find(m => m.id === id);
      if (!motor) return;

      const valid =
        batteryVoltage >= motor.voltageMin &&
        batteryVoltage <= motor.voltageMax;

      opt.hidden = !valid;
    });


  // ✅ FILTER CONTROLLERS
  const controllerOptions = elements.controllerSelect.querySelectorAll('option');

  controllerOptions.forEach(opt => {
    const id = parseInt(opt.value, 10);
    if (!id) return;

    const controller = data.controllers.find(c => c.id === id);
    if (!controller) return;

    const valid =
      batteryVoltage >= controller.voltageMin &&
      batteryVoltage <= controller.voltageMax;

    opt.hidden = !valid;
  });


  // ✅ Reset motor if invalid
if (selectedMotor) {

  const valid =
    batteryVoltage >= selectedMotor.voltageMin &&
    batteryVoltage <= selectedMotor.voltageMax;

  if (!valid) {

    selectedMotor = null;

    elements.motorSelect.value = '';

    elements.motorSpecs.innerHTML =
      '<p class="placeholder-text">Select a motor</p>';
  }
}

  // ✅ OPTIONAL: reset controller if invalid
  if (selectedController) {
    const valid =
      batteryVoltage >= selectedController.voltageMin &&
      batteryVoltage <= selectedController.voltageMax;

    if (!valid) {
      selectedController = null;
      elements.controllerSelect.value = '';
      elements.controllerSpecs.innerHTML =
        '<p class="placeholder-text">Select a controller</p>';
    }
  }

  updateCombined();
}

  function onMotorChange() {
    const id = parseInt(elements.motorSelect.value, 10);
    selectedMotor = data.motors.find(m => m.id === id) || null;
    renderMotorSpecs();
    updateCombined();
  }

  function onControllerChange() {
    const id = parseInt(elements.controllerSelect.value, 10);
    selectedController = data.controllers.find(c => c.id === id) || null;
    renderControllerSpecs();
    updateCombined();
  }

  function setupVendorButtons() {

  const container = document.getElementById('vendor-buttons');
  if (!container) return;

  const vendors = [...new Set(data.motors.map(m => m.vendor))]
    .filter(Boolean)
    .sort();

  container.innerHTML = `
    <button class="vendor-btn active" data-vendor="">
      All
    </button>
  `;

  vendors.forEach(vendor => {

    const btn = document.createElement('button');

    btn.className = 'vendor-btn';
    btn.dataset.vendor = vendor;
    btn.textContent = vendor;

    container.appendChild(btn);
  });

  container.querySelectorAll('.vendor-btn').forEach(btn => {

    btn.addEventListener('click', () => {

      selectedVendor = btn.dataset.vendor;

      container.querySelectorAll('.vendor-btn')
        .forEach(b => b.classList.remove('active'));

      btn.classList.add('active');

      populateDropdowns();

      // clear previous motor if filtered out
      selectedMotor = null;
      elements.motorSelect.value = '';

      renderMotorSpecs();
      updateCombined();

    });

  });

}

  // =========================
  // VOLTAGE PILLS
  // =========================

  function setupVoltagePills() {

    const panel = document.querySelector('.battery-voltage-panel');
    if (!panel) return;

    const container = document.createElement('div');
    container.className = 'voltage-markers';

    container.innerHTML = `
      <span data-v="24">24V</span>
      <span data-v="48">48V</span>
      <span data-v="96">96V</span>
      <span data-v="350">350V</span>
      <span data-v="700">700V</span>
    `;

    panel.appendChild(container);

    const pills = container.querySelectorAll('span');

    function updateUI(v) {
      pills.forEach(p =>
        p.classList.toggle('active', Number(p.dataset.v) === v)
      );
    }

    pills.forEach(p => {
      p.addEventListener('click', () => {
        batteryVoltage = Number(p.dataset.v);
        elements.voltageDisplay.textContent = batteryVoltage + 'V (default)';
        updateUI(batteryVoltage);
        filterByVoltage();
        updateCombined();
      });
    });

    updateUI(batteryVoltage);
  }

  // =========================
  // PERFORMANCE MODEL
  // =========================

function calculateCombinedSpecs(motor, controller) {

  const contAmps = Math.min(motor.contAmps, controller.contAmps);
  const peakAmps = Math.min(motor.peakAmps, controller.peakAmps);

  const contTorque =
    motor.torqueConstant *
    contAmps *
    (motor.contEfficiency || 0.95);

  const peakTorque =
    motor.torqueConstant *
    peakAmps *
    (motor.peakEfficiency || 0.85);

  const vScale = batteryVoltage / motor.voltageNominal;

  const contPowerKw = (motor.contPowerKw || 0) * vScale;
  const peakPowerKw = (motor.peakPowerKw || 0) * vScale;

  const maxRpm = Math.round(motor.maxRpm);

  const contCornerRpm =
    contTorque > 0 ? (contPowerKw / contTorque) * 9548.8 : 0;

  const peakCornerRpm =
    peakTorque > 0 ? (peakPowerKw / peakTorque) * 9548.8 : 0;

  const curve = [];

  for (let rpm = 0; rpm <= maxRpm; rpm += maxRpm / 30) {

    // ✅ safe rpm
    let rpm_local = rpm > 0 ? rpm : 1;

    // ✅ power (kW)
    let c_Power = Math.min((contTorque * rpm_local / 9548.8), contPowerKw);
    let p_Power = Math.min((peakTorque * rpm_local / 9548.8), peakPowerKw);

    // ✅ torque (Nm)
    let cont = Math.min(contTorque, c_Power * 9548.8 / rpm_local);
    let peak = Math.min(peakTorque, p_Power * 9548.8 / rpm_local);

    curve.push({
      rpm,
      contTorque: cont || 0,
      peakTorque: peak || 0
    });
  }

  return {
    contAmps,
    peakAmps,
    contTorque,
    peakTorque,
    contPowerKw,
    peakPowerKw,
    contCornerRpm: Math.round(contCornerRpm),
    peakCornerRpm: Math.round(peakCornerRpm),
    maxRpm,
    curve
  };
}

  // =========================
  // UPDATE UI
  // =========================

  function updateCombined() {

    if (!selectedMotor || !selectedController) {
      elements.chartSection.style.display = 'none';
      elements.combinedSpecs.innerHTML =
        '<p class="placeholder-text">Select both a motor and controller</p>';
      return;
    }

    const combo = calculateCombinedSpecs(selectedMotor, selectedController);

elements.combinedSpecs.innerHTML = `

  <div class="stat-card stat-highlight">
    <span class="stat-value">${combo.peakTorque.toFixed(1)}</span>
    <span class="stat-unit">Nm</span>
    <span class="stat-label">Peak Torque</span>
  </div>

  <div class="stat-card">
    <span class="stat-value">${combo.contTorque.toFixed(1)}</span>
    <span class="stat-unit">Nm</span>
    <span class="stat-label">Continuous Torque</span>
  </div>

  <div class="stat-card stat-highlight">
    <span class="stat-value">${combo.peakPowerKw.toFixed(1)}</span>
    <span class="stat-unit">kW</span>
    <span class="stat-label">Peak Power</span>
  </div>

  <div class="stat-card">
    <span class="stat-value">${combo.contPowerKw.toFixed(1)}</span>
    <span class="stat-unit">kW</span>
    <span class="stat-label">Continuous Power</span>
  </div>

  <div class="stat-card">
    <span class="stat-value">${combo.contCornerRpm.toLocaleString()}</span>
    <span class="stat-unit">RPM</span>
    <span class="stat-label">Corner Speed</span>
  </div>

  <div class="stat-card">
    <span class="stat-value">${combo.maxRpm.toLocaleString()}</span>
    <span class="stat-unit">RPM</span>
    <span class="stat-label">Max RPM</span>
  </div>

`;

    let recommendation = '';
    let reason = '';

    const currentRatio = selectedController.contAmps / selectedMotor.contAmps;
    const powerRatio   = selectedController.contPowerKw / selectedMotor.contPowerKw;

    // ✅ Recommended
    if (currentRatio >= 0.9 && powerRatio >= 0.9) {

      recommendation = '✅ Recommended pairing';
      reason = 'Controller supports full motor performance';

    }

    // ✅ Limited (diagnostic)
    else {

      recommendation = '⚠️ Limited performance';

      if (currentRatio < powerRatio) {
        reason = `Current limited: controller provides ${Math.round(currentRatio * 100)}% of required current`;
      } else {
        reason = `Power limited: controller provides ${Math.round(powerRatio * 100)}% of required power`;
      }

    }

    // ✅ ACTIONS
    const actions = document.createElement('div');
    actions.className = 'config-actions';

actions.innerHTML = `
  <div class="recommendation">
  ${recommendation}
  <div class="recommendation-detail">${reason}</div>
</div>


  <div class="config-actions-row">
    <button id="share-btn">Copy Link</button>
  </div>

  <div class="config-actions-row">
    <button id="enquire-btn" class="btn-primary">
      Enquire about this setup
    </button>
  </div>
`;

    elements.combinedSpecs.appendChild(actions);

    // ✅ EMAIL (FULL DATA)
    document.getElementById('enquire-btn').onclick = () => {
      const msg = `
          Drive Kit Enquiry from Voltsport Shopify website

          APPLICATION:
          ${selectedApplication ? selectedApplication : 'Not specified'}

          MOTOR:
          ${selectedMotor.title}

          CONTROLLER:
          $${selectedController.title}

          SYSTEM:
          Battery Voltage: ${batteryVoltage}V

          PERFORMANCE:
          Peak Torque: ${combo.peakTorque.toFixed(1)} Nm
          Continuous Torque: ${combo.contTorque.toFixed(1)} Nm
          Peak Power: ${combo.peakPowerKw.toFixed(1)} kW
          Continuous Power: ${combo.contPowerKw.toFixed(1)} kW
          `;
      window.location.href =
        `mailto:sales@voltsport.co.uk?subject=Drive Kit Enquiry&body=${encodeURIComponent(msg)}`;
    };

    // ✅ SHARE
    const url = new URL(window.location.href);
    url.searchParams.set('motor', selectedMotor.handle);
    url.searchParams.set('controller', selectedController.handle);
    url.searchParams.set('voltage', batteryVoltage);

    document.getElementById('share-btn').onclick = () => {
      navigator.clipboard.writeText(url.toString());
    };

    elements.chartSection.style.display = 'block';
    renderChart(combo.curve);
  }

  // =========================
  // CHART
  // =========================

  function renderChart(curve) {

  
    if (!elements.chartCanvas || typeof Chart === 'undefined') return;

    const ctx = elements.chartCanvas.getContext('2d');

    if (chart) chart.destroy();

    chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: curve.map(p => p.rpm),
        datasets: [
          {
            label: 'Peak Torque',
            data: curve.map(p => p.peakTorque),
            borderColor: '#e63946',
            tension: 0.3,
            pointRadius: 0
          },
          {
            label: 'Continuous Torque',
            data: curve.map(p => p.contTorque),
            borderColor: '#2a9d8f',
            tension: 0.3,
            pointRadius: 0
          }
        ]
      },
      
      options: {
  responsive: true,
  maintainAspectRatio: false,

        plugins: {
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function(context) {
                return `${context.dataset.label}: ${context.parsed.y.toFixed(1)} Nm`;
              }
            }
          }
        },

        interaction: {
          mode: 'index',
          intersect: false
        },

        
      scales: {
          x: {
            title: {
              display: true,
              text: 'Speed (RPM)'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Torque (Nm)'
            }
          }
        }
    }
    });
  }

  // =========================
  // SPECS
  // =========================

function renderMotorSpecs() {

  if (!elements.motorSpecs) return;

  if (!selectedMotor) {
    elements.motorSpecs.innerHTML =
      '<p class="placeholder-text">Select a motor to view specifications</p>';
    return;
  }

  const m = selectedMotor;

  elements.motorSpecs.innerHTML = `
    <div class="spec-card">

      <a href="${m.url}" class="spec-image-link">
        <img src="${m.image}" class="spec-image" loading="lazy">
      </a>

      <div class="spec-details">

        <h3 class="spec-title">
          ${m.title}
        </h3>

        <dl class="spec-list">

          <div class="spec-row">
            <dt>Torque Constant</dt>
            <dd>${m.torqueConstant} Nm/A</dd>
          </div>

          <div class="spec-row">
            <dt>Continuous Current</dt>
            <dd>${m.contAmps} A</dd>
          </div>

          <div class="spec-row">
            <dt>Peak Current</dt>
            <dd>${m.peakAmps} A</dd>
          </div>

          <div class="spec-row">
            <dt>Continuous Power</dt>
            <dd>${m.contPowerKw} kW</dd>
          </div>

          <div class="spec-row">
            <dt>Peak Power</dt>
            <dd>${m.peakPowerKw} kW</dd>
          </div>

          <div class="spec-row">
            <dt>Nominal Voltage</dt>
            <dd>${m.voltageNominal} V</dd>
          </div>

          <div class="spec-row">
            <dt>Max RPM</dt>
            <dd>${m.maxRpm.toLocaleString()}</dd>
          </div>

        </dl>

        <a href="${m.url}" class="spec-link">View product →</a>

      </div>
    </div>
  `;
}

function renderControllerSpecs() {

  if (!elements.controllerSpecs) return;

  if (!selectedController) {
    elements.controllerSpecs.innerHTML =
      '<p class="placeholder-text">Select a controller to view specifications</p>';
    return;
  }

  const c = selectedController;

  elements.controllerSpecs.innerHTML = `
    <div class="spec-card">

      <a href="${c.url}" class="spec-image-link">
        <img src="${c.image}" class="spec-image" loading="lazy">
      </a>

      <div class="spec-details">

        <h3 class="spec-title">
          ${c.title}
        </h3>

        <dl class="spec-list">

          <div class="spec-row">
            <dt>Continuous Current</dt>
            <dd>${c.contAmps} A</dd>
          </div>

          <div class="spec-row">
            <dt>Peak Current</dt>
            <dd>${c.peakAmps} A</dd>
          </div>

          <div class="spec-row">
            <dt>Continuous Power</dt>
            <dd>${c.contPowerKw} kW</dd>
          </div>

          <div class="spec-row">
            <dt>Peak Power</dt>
            <dd>${c.peakPowerKw} kW</dd>
          </div>

          <div class="spec-row">
            <dt>Voltage Range</dt>
            <dd>${c.voltageMin} – ${c.voltageMax} V</dd>
          </div>

          <div class="spec-row">
            <dt>Nominal Voltage</dt>
            <dd>${c.voltageNominal} V</dd>
          </div>

        </dl>

        <a href="${c.url}" class="spec-link">View product →</a>

      </div>
    </div>
  `;
}

function setupApplicationIcons() {

  const cards = document.querySelectorAll('.app-card');

  cards.forEach(card => {
    card.addEventListener('click', () => {

      // ✅ store selection
      selectedApplication = card.dataset.app;

      // ✅ update active state (visual highlight)
      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

    });
  });
}

  // =========================
  // URL RESTORE
  // =========================

  function restoreFromURL() {

    const params = new URLSearchParams(window.location.search);

    const m = data.motors.find(x => x.handle === params.get('motor'));
    const c = data.controllers.find(x => x.handle === params.get('controller'));

    if (m) {
      selectedMotor = m;
      elements.motorSelect.value = m.id;
    }

    if (c) {
      selectedController = c;
      elements.controllerSelect.value = c.id;
    }

    if (params.get('voltage')) {
      batteryVoltage = Number(params.get('voltage'));
      elements.voltageDisplay.textContent = batteryVoltage + 'V';
    }

    updateCombined();
  }

  document.addEventListener('DOMContentLoaded', init);

})();